import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { QuickPickDTO } from '../quick-picks-dtos';

@Component({
  selector: 'app-prize-table-form-field',
  templateUrl: './quick-picks-form-field.component.html',
  styleUrls: ['./quick-picks-form-field.component.scss'],
  standalone: false,
})
export class QuickPicksFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: QuickPickDTO[];

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public tableData: MatTableDataSource<any>;

  public displayedFieldsNames: string[];

  public fields: FieldConfigDTO[];

  ngOnInit() {
    if (!this.data) {
      this.data = [
        {
          numberQuickPicks: 3,
          onBanner: true,
        },
        {
          numberQuickPicks: 6,
          onBanner: false,
        },
        {
          numberQuickPicks: 12,
          onBanner: false,
        },
      ];
    }

    this.formGroup.get(this.fieldConfig.name).setValue(this.data);
    this.fields = [
      {
        name: 'numberQuickPicks',
        label: 'Number of quick picks',
        type: DataType.number,
      },
      {
        name: 'onBanner',
        label: 'On banner',
        type: DataType.checkbox,
      },
    ];

    this.displayedFieldsNames = this.fields.map((f) => f.name);
    this.tableData = new MatTableDataSource(this.data);
  }

  onValueChanged(value: any[] | any) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    formControl.setValue(value);
  }
}
